<script>
import RoulettePreviewExperience from "@/components/roulette-preview/RoulettePreviewExperience.vue";

const europeanSequence = [
  0,
  32,
  15,
  19,
  4,
  21,
  2,
  25,
  17,
  34,
  6,
  27,
  13,
  36,
  11,
  30,
  8,
  23,
  10,
  5,
  24,
  16,
  33,
  1,
  20,
  14,
  31,
  9,
  22,
  18,
  29,
  7,
  28,
  12,
  35,
  3,
  26
];

const redNumbers = [
  1,
  3,
  5,
  7,
  9,
  12,
  14,
  16,
  18,
  19,
  21,
  23,
  25,
  27,
  30,
  32,
  34,
  36
];

const roulettePockets = europeanSequence.map(number => ({
  id: `pocket-${number}`,
  number,
  color:
    number === 0
      ? "#0b744e"
      : redNumbers.includes(number)
      ? "#a92f2c"
      : "#171b19",
  textColor: number === 0 ? "#fff0ad" : "#f7e6c8"
}));

const rouletteRewards = [
  0,
  33,
  44,
  50,
  60,
  65,
  70,
  75,
  80,
  85,
  90,
  95,
  100,
  200
].map(amount => ({
  id: `reward-${amount}`,
  amount
}));

export default {
  name: "RouletPreview",
  components: {
    RoulettePreviewExperience
  },
  data() {
    return {
      pockets: roulettePockets,
      rewards: rouletteRewards,
      initialBalance: 8888,
      depositToday: 1240,
      depositGoal: 1000
    };
  }
};
</script>

<template>
  <RoulettePreviewExperience
    :pockets="pockets"
    :rewards="rewards"
    :initial-balance="initialBalance"
    :deposit-today="depositToday"
    :deposit-goal="depositGoal"
  />
</template>
